import { Component, ViewChildren, QueryList, OnDestroy } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';
import { Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'labeled-multi-select',
  template: `
    <div class="tw-flex tw-items-center">
      <p *ngIf="to.label" class="tw-w-16">{{to.label}}</p>
      <mat-form-field class="tw-w-full">
        <mat-label>Choose a type</mat-label>
        <mat-select
          [ngClass]="{'is-drop-down': to.label === 'Is:', 'is-not-drop-down': to.label === 'Is Not:'}"
          [formControl]="formControl" multiple (selectionChange)="selectionChanged(field, $event)">
          <mat-select-trigger>
            ({{ selectedAmount }} selected)
          </mat-select-trigger>
          <ng-container>
            <mat-option *ngFor="let option of to.options | async" [value]="option">{{option.name}}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="tw-mb-6">
      <mat-chip-listbox>
        <ng-container>
          <mat-chip
            class="edit-state-chip"
            *ngFor="let chip of chips"
            [selectable]="selectable"
            [removable]="removable"
            (removed)="remove(chip)">
              {{ chip.name }}
              <mat-icon
                matChipRemove
                *ngIf="removable"
                class="material-icons-outlined white-icon white-icon-svg mat-chip-remove">close</mat-icon>
          </mat-chip>
        </ng-container>
      </mat-chip-listbox>
    </div>
  `,
  standalone: false
})

export class LabeledMultiSelectComponent extends FieldType<FieldTypeConfig> implements OnDestroy{
  @ViewChildren(MatOption) set optionList(optionList: QueryList<MatOption>) {
    this._optionList = optionList;
    if (this.to.options && !this.optionListSet) {
      (this.to.options as Observable<any>).pipe(takeUntil(this.destroyS)).subscribe((options) => {
        setTimeout(() => {
          this.optionsSelected = options;
            if(this.to.defaultValue && options.length) {
                this.to.defaultValue(this.formControl, this);
            }
          });
          if (!this.optionListSet && optionList.length) {
            this.optionListSet = true;
          }
        });
      }
  }

  get optionList() {
    return this._optionList;
  }

  selectedAmount: number = 0;
  chips: string[] | [] = [];
  selectable = true;
  removable = true;
  destroyS = new Subject<boolean>();
  optionsSelected: any = [];
  optionListSet = false;
  private _optionList: QueryList<MatOption>;

  selectionChanged(field, matSelect: MatSelect) {
    this.chips = matSelect.value;
    if (this.selectedAmount !== matSelect.value.length) {
      this.selectedAmount = matSelect.value.length;
    }
  }

  ngOnDestroy() {
    this.destroyS.next(true);
  }

  // Fire when the X on a MatChip is clicked
  remove(chip: string): void {
    if (this.to.remove) {
      this.to.remove(chip, this);
    }
  }

}
